import React from "react";
import CommonHeader from "../Common Header/CommonHeader";

const SchoolInfo1 = () => {
  const handlePdfOpen = () => {
    window.open("#", "_blank");
  };

  return (
    <>
      {/* <CommonHeader heading={"INFORMATION ABOUT SCHOOL"} /> */}
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            {/* Header with PDF Button */}
            <div className="row">
              <h1 className="text-center">INFORMATION ABOUT SCHOOL</h1>
            </div>

            {/* Information of the school Section */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">
                  <strong>Information of the school</strong>
                </h3>
              </div>
              <div className="panel-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr className="info">
                        <th className="col-xs-2">Sr. No</th>
                        <th className="col-xs-4">Information</th>
                        <th className="col-xs-6">Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {/* <td>1.</td> */}
                        <td colSpan={2}>Name of the School with address</td>
                        <td>
                          Rama Krishna Public School,Sec 69, Tulip Road,
                          Badshahpur, Haryana-122101
                        </td>
                      </tr>
                      <tr>
                        <td className="text-right">1.</td>
                        <td>Email</td>
                        <td>
                          <a
                            href="mailto:rkps12021@gmail.com"
                            className="text-primary"
                          >
                            rkps12021@gmail.com
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-right">2.</td>
                        <td>Ph. No.</td>
                        <td>9643440055</td>
                      </tr>
                      <tr>
                        <td className="text-right">3.</td>
                        <td>Fax No.</td>
                        <td>NA</td>
                      </tr>
                      <tr>
                        {/* <td>2.</td> */}
                        <td colSpan={2}>
                          Whether NOC from State/UT or recommendation of Embassy
                          of India obtained?
                        </td>
                        <td>Yes</td>
                      </tr>
                      <tr>
                        <td className="text-right">1.</td>
                        <td>NOC No.</td>
                        <td>NOC112024298</td>
                      </tr>
                      <tr>
                        <td className="text-right">2.</td>
                        <td>NOC issuing date</td>
                        <td>31.12.2024</td>
                      </tr>
                      <tr>
                        {/* <td>3.</td> */}
                        <td colSpan={2}>
                          Is the school is recognised, if yes by which Authority
                        </td>
                        <td>Yes, Haryana Board</td>
                      </tr>
                      <tr>
                        {/* <td>4.</td> */}
                        <td colSpan={2}>Status of affiliation</td>
                        <td>Permanent</td>
                      </tr>
                      <tr>
                        <td className="text-right">1.</td>
                        <td>Affiliation No.</td>
                        <td>5040</td>
                      </tr>
                      <tr>
                        <td className="text-right">2.</td>
                        <td>Affiliation with the Board since</td>
                        <td>1.04.2024</td>
                      </tr>
                      <tr>
                        <td className="text-right">3.</td>
                        <td>Extension of affiliation upto</td>
                        <td>1.04.2035</td>
                      </tr>
                      <tr>
                        {/* <td>5.</td> */}
                        <td colSpan={2}>
                          Name of Trust /Society /Company Registered under
                          Section 25 of the company Act, 1956. Period upto which
                          Registration of Trust /Society is valid
                        </td>
                        <td>
                          Kirpa Devi Samaj Kalyan & Shiksha Samiti, Valid untill
                          it is dissolved
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={3}><a href="assets/pdf/GOVERNING COUNCIL, PARENTS TEACHER ASSOCIATION.pdf" target="_blank">PTA</a></td>
                      </tr>
                      <tr><td colSpan={3}><a href="assets/pdf/GRIEVANCECOMPLAINT REDRESSAL COMMITTEE.pdf" target="_blank">Grievance Redressal Committee</a></td></tr>
                      <tr><td colSpan={3}><a href="assets/pdf/Sexual Harrasment Committee.pdf" target="_blank">Sexual Harassment Committee (POSH Committee)</a></td></tr>
                      <tr><td colSpan={3}><a href="assets/pdf/SELF - CERTIFICATION PROFORMA.pdf" target="_blank">Self Affidavit of School</a></td></tr>
                      <tr>
                        <td colSpan={3}>
                          <strong>Audit Reports</strong>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-right">1.</td>
                        <td colSpan={2}><a href="assets/pdf/AUDIT REPORT -2022.pdf" target="_blank">AUDIT REPORT - 2022</a></td>
                      </tr>
                      <tr>
                        <td className="text-right">2.</td>
                        <td colSpan={2}><a href="assets/pdf/AUDIT REPORT -2023.pdf" target="_blank">AUDIT REPORT - 2023</a></td>
                      </tr>
                      <tr>
                        <td className="text-right">3.</td>
                        <td colSpan={2}><a href="assets/pdf/AUDIT REPORT -2024.pdf" target="_blank">AUDIT REPORT - 2024</a></td>
                      </tr>
                      <tr>
                        {/* <td>10.</td> */}
                        <td colSpan={2}>Name and official address of the Director</td>
                        <td>Parveen Yadav</td>
                      </tr>
                      <tr>
                        <td className="text-right">1.</td>
                        <td>E-mail</td>
                        <td>
                          <a
                            href="mailto:Rkps12021@gmail.com"
                            className="text-primary"
                          >
                            Rkps12021@gmail.com
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-right">2.</td>
                        <td>Ph. No.</td>
                        <td>
                          <a href="tel:9643440055" className="text-primary">
                            9643440055
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-right">3.</td>
                        <td>Fax No.</td>
                        <td>NA</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Area of school campus Section */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">
                  <strong>Area of school campus</strong>
                </h3>
              </div>
              <div className="panel-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr className="info">
                        <th className="col-xs-2">Sr. No</th>
                        <th className="col-xs-4">Information</th>
                        <th className="col-xs-6">Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {/* <td>11.</td> */}
                        <td colSpan={2}>Area of school campus</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td className="text-right">1.</td>
                        <td>Total Campus Area of the School (in Acres)</td>
                        <td>1.0640 Acres</td>
                      </tr>
                      <tr>
                        <td className="text-right">2.</td>
                        <td>Built up Area (Ground Floor)</td>
                        <td>11678 Sq ft</td>
                      </tr>
                      <tr>
                        <td className="text-right">3.</td>
                        <td>Area of Playground (in sq ft)</td>
                        <td>34671.21 Sq ft</td>
                      </tr>
                      <tr>
                        {/* <td></td> */}
                        <td colSpan={2}>
                          <strong>Other facilities</strong>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <td className="text-right">a)</td>
                        <td>Swimming Pool</td>
                        <td>No</td>
                      </tr>
                      <tr>
                        <td className="text-right">b)</td>
                        <td>Indoor games</td>
                        <td>Yes</td>
                      </tr>
                      <tr>
                        <td className="text-right">c)</td>
                        <td>Dance Rooms</td>
                        <td>No</td>
                      </tr>
                      <tr>
                        <td className="text-right">d)</td>
                        <td>Gymnasium</td>
                        <td>No</td>
                      </tr>
                      <tr>
                        <td className="text-right">e)</td>
                        <td>Music Rooms</td>
                        <td>Yes</td>
                      </tr>
                      <tr>
                        <td className="text-right">f)</td>
                        <td>Hostels</td>
                        <td>No</td>
                      </tr>
                      <tr>
                        <td className="text-right">g)</td>
                        <td>Health and Medical Check up</td>
                        <td>Yes</td>
                      </tr>
                      <tr>
                        <td colSpan={3}><strong>Details of curriculam</strong></td>
                      </tr>
                      <tr>
                        <td colSpan={3}><a href="assets/pdf/Classes III to VIIIUnit 1 and Term 1 session 2025-2026.pdf">Classes (III-VIII) Unit I and Term I Session 2025-26</a></td>
                      </tr>
                      <tr>
                        <td colSpan={3}><a href="assets/pdf/Unit II and Term II session 2025-2026.pdf">Classes (III-VIII) Unit II and Term II Session 2025-26</a></td>
                      </tr>
                      <tr>
                        <td colSpan={3}><a href="#">Classes (III-VIII) Unit III Session 2025-26</a></td>
                      </tr>
                      <tr>
                        <td colSpan={3}><a href="/achievements">Achievements/Laurels</a></td>
                      </tr>
                      <tr>
                        <td colSpan={3}><a href="#">Notice Board</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Payment Information Section */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">
                  <strong>Payment and Other Information</strong>
                </h3>
              </div>
              <div className="panel-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr className="info">
                        <th className="col-xs-2">Sr. No</th>
                        <th className="col-xs-4">Information</th>
                        <th className="col-xs-6">Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {/* <td>16.</td> */}
                        <td colSpan={2}>Mode of payment of salary</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td className="text-right">i)</td>
                        <td>
                          Name of the Bank through which salary is drawing
                        </td>
                        <td>HDFC Bank Ltd.</td>
                      </tr>
                      <tr>
                        <td className="text-right">ii)</td>
                        <td>Through single cheque transfer advice</td>
                        <td>Yes</td>
                      </tr>
                      <tr>
                        <td className="text-right">iii)</td>
                        <td>Individual cheque</td>
                        <td>No.</td>
                      </tr>
                      <tr>
                        <td className="text-right">iv)</td>
                        <td>Cash</td>
                        <td>No.</td>
                      </tr>
                      <tr>
                        {/* <td>17.</td> */}
                        <td colSpan={2}>EPFO Establishment ID:</td>
                        <td>GNGGN3685607000</td>
                      </tr>
                      <tr>
                        {/* <td>18.</td> */}
                        <td colSpan={3}>Library facilities</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td className="text-right">i)</td>
                        <td>Size of Library (in sq ft)</td>
                        <td>1200 sq ft</td>
                      </tr>
                      <tr>
                        {/* <td>19.</td> */}
                        <td colSpan={2}>
                          Name of the Grievance /redressal Officer with E-mail,
                          Ph. No., Fax No.
                        </td>
                        <td>
                          Parveen Yadav
                          <br />
                          E-mail: <a href="mailto:rkps12021@gmail.com" className="text-primary">
                            rkps12021@gmail.com
                          </a>
                          <br />
                          Phone No. :{" "}
                          <a href="tel:9643440055" className="text-primary">
                            9643440055
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Sexual Harassment Committee Section */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">
                  <strong>Members of Sexual Harassment Committee</strong>
                </h3>
              </div>
              <div className="panel-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr className="info">
                        <th className="col-xs-2">Sr. No</th>
                        <th className="col-xs-10">Members</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {/* <td>20.</td> */}
                        <td colSpan={3}>Members of Sexual Harassment Committee</td>
                      </tr>
                      <tr>
                        {/* <td></td> */}
                        <td colSpan={3}>
                          i. Ms. Kalpana Raghav (President)
                          <br />
                          ii. Ms. Reena Yadav (Member)
                          <br />
                          iii. Ms. Suraksha Bhatti (Member)
                          <br />
                          iv. Ms. Taruna (Member)
                          <br />
                          v. Ms. Savita Yadav (Social Worker)
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Section wise enrollment Section */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">
                  <strong>
                    Section wise enrollment of school for the current session
                    (2025-26)
                  </strong>
                </h3>
              </div>
              <div className="panel-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr className="info">
                        <th className="col-xs-3">Class</th>
                        <th className="col-xs-3">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {/* <td>21.</td> */}
                        <td colSpan={2}>
                          Section wise enrollment of school for the current
                          session (2025-26)
                        </td>
                      </tr>
                      <tr>
                        <td>Bal Vatika I</td>
                        <td>20</td>
                      </tr>
                      <tr>
                        <td>Bal Vatika II</td>
                        <td>22</td>
                      </tr>
                      <tr>
                        <td>Bal Vatika III</td>
                        <td>25</td>
                      </tr>
                      <tr>
                        <td>I</td>
                        <td>28</td>
                      </tr>
                      <tr>
                        <td>II</td>
                        <td>27</td>
                      </tr>
                      <tr>
                        <td>III</td>
                        <td>26</td>
                      </tr>
                      <tr>
                        <td>IV</td>
                        <td>33</td>
                      </tr>
                      <tr>
                        <td>V</td>
                        <td>24</td>
                      </tr>
                      <tr>
                        <td>VI</td>
                        <td>14</td>
                      </tr>
                      <tr>
                        <td>VII</td>
                        <td>23</td>
                      </tr>
                      <tr>
                        <td>VIII</td>
                        <td>17</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Academic and Admission Information Section */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">
                  <strong>Academic and Admission Information</strong>
                </h3>
              </div>
              <div className="panel-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr className="info">
                        <th className="col-xs-4">Information</th>
                        <th className="col-xs-6">Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Academic session period</td>
                        <td>From April to March</td>
                      </tr>
                      <tr>
                        <td>Vacation period</td>
                        <td>From 31 May to 1 July</td>
                      </tr>
                      <tr>
                        <td>Admission period</td>
                        <td>From November to March</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SchoolInfo1;
